import React from 'react'

export const FreeBadge = () => {
    return (
        <div className="flex px-2 py-1 rounded-xl items-center bg-yf-green">
            <i aria-hidden className="fak fa-free-badge text-sm text-white"></i>
            <div className="mr-1" />
            <p className="text-xs text-white font-normal">TRY FOR FREE</p>
        </div>
    )
}
